var _clipPath, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDirectClash(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0.0 0.0 944.8818897637796 944.8818897637796",
    fill: "none",
    stroke: "none",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "p.0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0l944.8819 0l0 944.8819l-944.8819 0l0 -944.8819z",
    clipRule: "nonzero"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#p.0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m0 0l944.8819 0l0 944.8819l-944.8819 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "p.1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(33.925938067930424 0.0 0.0 33.925938067930424 0.0 0.0)",
    spreadMethod: "pad",
    x1: -10.0636032116275,
    y1: 13.935206976013353,
    x2: 13.935206976013353,
    y2: 37.91491471749003
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d63031"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#d63031"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57000005,
    stopColor: "#ff7675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#ff7675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81000006,
    stopColor: "#fab1a0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fab1a0"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "url(#p.1)",
    d: "m65.51181 472.44095l0 0c0 -224.74075 182.18839 -406.92914 406.92914 -406.92914l0 0c107.924286 0 211.42831 42.872772 287.74234 119.18678c76.314026 76.31401 119.18677 179.81804 119.18677 287.74237l0 0c0 224.74075 -182.18835 406.9291 -406.9291 406.9291l0 0c-224.74075 0 -406.92914 -182.18835 -406.92914 -406.9291z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d63031",
    d: "m59.99576 182.88408l-42.267715 -158.11023l158.11024 42.267715z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d63031",
    d: "m769.04565 67.04156l158.11023 -42.267715l-42.26776 158.11023z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d63031",
    d: "m884.8881 761.9996l42.26776 158.11023l-158.11023 -42.2677z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d63031",
    d: "m175.83829 877.8421l-158.11024 42.2677l42.267715 -158.11023z",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirectClash);
export default __webpack_public_path__ + "static/media/direct_clash.bb7b304562466a50f2de10ac3bf1d94f.svg";
export { ForwardRef as ReactComponent };